import admin from './admin';
import affiliate from './affiliate';
import auth from './auth';
import billing from './billing';
import billingV3 from './billingV3';
import bulkEdit from './bulkEdit';
import connectProfile from './connectProfile';
import data from './data';
import edit from './edit';
import listings from './listings';
import mediaLibrary from './mediaLibrary';
import notifications from './notifications';
import profiles from './profiles';
import schedule from './schedule';
import selectPhotos from './selectPhotos';
import shops from './shops';
import studioEditor from './studioEditor';
import user from './user';

const actions = {
  admin,
  affiliate,
  auth,
  billing,
  billingV3,
  bulkEdit,
  connectProfile,
  data,
  edit,
  listings,
  mediaLibrary,
  notifications,
  profiles,
  schedule,
  selectPhotos,
  studioEditor,
  shops,
  user,
};

export default actions;
